import { ReactNode } from 'react';
import { P, S, T } from '../../../styles/tokens';

interface BriefSectionProps {
  /** Section number displayed as zero-padded monospace badge (e.g. "01"). */
  num: string;
  /** Emoji shown in terracotta circle. */
  emoji: string;
  /** Section title rendered in title3. */
  title: string;
  children: ReactNode;
}

/** Numbered section container for the brief screen.
 *  Mirrors pantene-flow.jsx BriefSection (line 560). */
export function BriefSection({ num, emoji, title, children }: BriefSectionProps) {
  return (
    <div style={{ marginTop: 22 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: 14,
            background: P.terraSoft,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 14,
          }}
        >
          {emoji}
        </div>
        <div style={{ font: T.title3, color: S.label, flex: 1 }}>{title}</div>
        <div
          style={{
            font: T.caption,
            fontWeight: 700,
            color: S.tertiaryLabel,
            fontFamily: T.fontMono,
          }}
        >
          0{num}
        </div>
      </div>
      {children}
    </div>
  );
}
